const name = 'CollapseOut';
const properties = {
    groups: ['exit', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        power: {
            type: 'string',
            enum: ['soft', 'medium', 'hard'],
            default: 'hard',
        },
    },
};
const scaleMap = {
    soft: 0.85,
    medium: 0.4,
    hard: 0,
};
/**
 * Collapse Out
 */
function animate(kit, elements, duration, delay, { power = properties.schema.power.default, ...params } = {}) {
    const sequence = kit.sequence(params);
    const scale = scaleMap[power];
    sequence.add([
        kit.animate('BaseFade', elements, duration, delay, {
            from: { opacity: 1 },
            to: { autoAlpha: 0 },
            ease: 'Cubic.easeOut',
        }),
        kit.animate('BaseScale', elements, duration, delay, {
            to: { scale },
            ease: 'Sine.easeOut',
        }),
    ]);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=collapseOut.js.map